module.exports = __webpack_public_path__ + "img/telegram-4.b96c937b.png";